var map = {
	"./edit-supplier.jpg": 96495,
	"./supplier-01.png": 10690,
	"./supplier-02.png": 73819,
	"./supplier-03.png": 74096,
	"./supplier-04.png": 43936,
	"./supplier-05.png": 39497,
	"./supplier-06.png": 57986,
	"./supplier-07.png": 73029,
	"./supplier-08.png": 71030,
	"./supplier-09.png": 89211,
	"./supplier-10.png": 83511,
	"./supplier1.png": 44916,
	"./supplier10.png": 25557,
	"./supplier2.png": 75694,
	"./supplier3.png": 72663,
	"./supplier4.png": 97093,
	"./supplier5.png": 43038,
	"./supplier6.png": 48075,
	"./supplier7.png": 44648,
	"./supplier8.png": 61302,
	"./supplier9.png": 78552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5569;